/* XK Promo Banner behaviors: countdown, copy code, whole-banner link, rotating messages, GTM tracking */
(function () {
  if (window.__xkPromo) return;
  window.__xkPromo = 1;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init() {
    document.querySelectorAll('[data-xk-promo]:not([data-xk-init])').forEach(function (el) {
      el.setAttribute('data-xk-init', '1');

      var link = el.getAttribute('data-xk-link');
      if (link) {
        el.style.cursor = 'pointer';
        el.addEventListener('click', function (e) {
          if (e.target.closest('.xk-promo__btn, .xk-promo-blk__btn')) return;
          window.location.href = link;
        });
      }

      var track = el.getAttribute('data-xk-track');
      if (track && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              io.disconnect();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: 'xk_promo_view', xk_promo_name: track });
            }
          });
        }, { threshold: 0.5 });
        io.observe(el);
      }

      var cd = el.querySelector('[data-xk-cd], [data-xk-cd-ev]');
      if (cd) {
        var end;
        var evHours = cd.getAttribute('data-xk-cd-ev');
        if (evHours) {
          var evKey = 'xkcd_' + (el.id || 'promo');
          var evStart = parseInt(localStorage.getItem(evKey), 10);
          if (!evStart) {
            evStart = Date.now();
            try { localStorage.setItem(evKey, evStart); } catch (e) { /* private mode */ }
          }
          end = evStart + parseInt(evHours, 10) * 3600000;
        } else {
          end = parseInt(cd.getAttribute('data-xk-cd'), 10) * 1000;
        }
        var out = cd.querySelector('.xk-promo__cd-time') || cd;
        var hideBanner = cd.hasAttribute('data-xk-cd-hide');
        var seg = cd.hasAttribute('data-xk-cd-seg');
        var hideDays = cd.hasAttribute('data-xk-cd-hidedays');
        var setSeg = function (name, val) {
          var n = cd.querySelector('[data-xk-seg="' + name + '"]');
          if (n) n.textContent = val;
        };
        var tick = function () {
          var d = end - Date.now();
          if (d <= 0) {
            clearInterval(timer);
            if (hideBanner) { el.style.display = 'none'; } else { cd.style.display = 'none'; }
            return;
          }
          var s = Math.floor(d / 1000);
          var days = Math.floor(s / 86400);
          var h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
          if (seg) {
            setSeg('d', pad(days)); setSeg('h', pad(h)); setSeg('m', pad(m)); setSeg('s', pad(sec));
            if (hideDays) {
              var du = cd.querySelector('[data-xk-days-unit]');
              if (du) du.style.display = days > 0 ? '' : 'none';
            }
          } else {
            out.textContent = (days > 0 ? days + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
          }
        };
        var timer = setInterval(tick, 1000);
        tick();
      }

      var rotRaw = el.getAttribute('data-xk-rotate');
      if (rotRaw) {
        var msgs = null;
        try { msgs = JSON.parse(rotRaw); } catch (e) { /* ignore bad json */ }
        var target = el.querySelector('[data-xk-rotate-target]');
        var iv = (parseInt(el.getAttribute('data-xk-rotate-int'), 10) || 3) * 1000;
        var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (msgs && msgs.length > 1 && target && !reducedMotion) {
          msgs = msgs.map(function (m) { return m.trim(); }).filter(Boolean);
          var i = 0;
          target.style.transition = 'opacity .35s ease';
          setInterval(function () {
            target.style.opacity = '0';
            setTimeout(function () {
              i = (i + 1) % msgs.length;
              target.textContent = msgs[i];
              target.style.opacity = '1';
            }, 350);
          }, iv);
        }
      }

      el.querySelectorAll('.xk-promo__btn, .xk-promo-blk__btn').forEach(function (btn) {
        btn.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && btn.getAttribute('data-xk-copy')) {
            e.preventDefault();
            btn.click();
          }
        });
        btn.addEventListener('click', function (e) {
          var code = btn.getAttribute('data-xk-copy');
          if (code) {
            e.preventDefault();
            e.stopPropagation();
            var fallback = function () {
              var ta = document.createElement('textarea');
              ta.value = code;
              document.body.appendChild(ta);
              ta.select();
              document.execCommand('copy');
              ta.remove();
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code).catch(fallback);
            } else { fallback(); }
            if (!btn.hasAttribute('data-xk-orig')) btn.setAttribute('data-xk-orig', btn.textContent);
            btn.textContent = btn.getAttribute('data-xk-copied') || 'COPIED!';
            setTimeout(function () { btn.textContent = btn.getAttribute('data-xk-orig'); }, 2000);
          }
          if (track) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'xk_promo_click', xk_promo_name: track, xk_promo_code: code || null });
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
